export default store => next => action =>
  next(
    action.type.indexOf('/') === -1
      ? {
          ...action,
          type: `redux/${action.type}`,
        }
      : action
  )



// WEBPACK FOOTER //
// ./src/redux/middleware/reduxSubscriptions.js